<template>
    <v-card>
        <v-toolbar fixed dark color="blue" class="darken-1">
            <v-toolbar-title>
                Edit Customer
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="dialogueClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-form>
                <v-container>
                    <v-row>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.firstName"
                                    label="First Name "
                                    required
                            ></v-text-field>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.lastName"
                                    label="Last Name"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-radio-group v-model="customerData.gender" row label="Gender">
                                <v-radio label="Male" value="male"></v-radio>
                                <v-radio label="Female" value="female"></v-radio>
                                <v-radio label="Other" value="other"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-menu
                                    v-model="snackbar.dateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            v-model="customerData.dateOfBirth"
                                            label="Date of Birth"
                                            clearable
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="customerData.dateOfBirth">

                                </v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.nationality"
                                    label="Nationality"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-autocomplete
                                    v-model="customerData.country"
                                    :items="countries"
                                    label="Country"
                                    clearable
                                    single-line
                                    item-text="value"
                                    item-value="id"
                                    @change="getState"
                            ></v-autocomplete>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-autocomplete
                                    v-model="customerData.state"
                                    :items="state"
                                    label="State"
                                    clearable
                                    single-line
                                    item-text="value"
                                    item-value="id"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="12"
                               sm="6" md="4">
                            <v-autocomplete v-model="customerData.ageGroup" :items="PassengerTypes"
                                            item-value="value"
                                            item-text="value"
                                            label="Age Group"></v-autocomplete>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.citizenShipNumber"
                                    label="Citizenship Number"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.passportNumber"
                                    label="Passport Number"
                                    required
                            ></v-text-field>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.licenseNumber"
                                    label="License Number "
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.otherID"
                                    label="Other Id "
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-img height="50" width="50"
                                   :src="customerData.document">
                            </v-img>
                            <v-file-input
                                    accept="image/png, image/jpeg, image/bmp"
                                    placeholder="Document"
                                    show-size
                                    label="Document"
                                    v-model="customerData.updateDocument"
                            ></v-file-input>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-switch class="col-sm-6 col-md-4"
                                      v-model="customerData.isVerifiedDocument"
                                      label="Is Verified Document?"
                                      clearable
                            ></v-switch>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.issuedBy"
                                    label="Issued By"
                                    required
                            ></v-text-field>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-autocomplete
                                    v-model="customerData.rateType"
                                    :items="rateType"
                                    label="Exchange Rate Type"
                                    @change="callExchangeRate"

                            ></v-autocomplete>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    type="number"
                                    v-model="customerData.fromAmount"
                                    label="From Amount"
                                    required
                            ></v-text-field>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-autocomplete
                                    v-model="customerData.ExchangeData"
                                    :items="exchangeRates"
                                    label="Exchange Rate"
                                    item-text="id"
                                    item-value="id"
                            ></v-autocomplete>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    type="number"
                                    v-model="customerData.toAmount"
                                    label="To Amount"
                                    required
                            ></v-text-field>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-menu
                                    v-model="snackbar.dateMenu3"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            v-model="customerData.issuedDate"
                                            label="Issued Date"
                                            clearable
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="customerData.issuedDate">

                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="red darken-1" @click="dialogueClose">Cancel</v-btn>
            <v-btn dark color="blue darken-1" @click="editFormSubmit">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";

    export default {
        name: "HelicopterCustomerEditForm",
        data() {
            return {
                customerData: {},
                customerFormData: [],
                message: {
                    status: true,
                    text: 'true',
                },
                snackbar: {
                    dateMenu: false,
                    dateMenu2: false,
                    dateMenu3: false,
                },
                countries: [],
                state: [],
                airList: [],
                Destinations: [],
                exchangeRates: [],
                rateType: ['Buy', 'Sell'],
                AirPackages: [],
                PassengerTypes: [],
                FlightClasses: [],
                Issuer: ['E-Sewa'],
                personType: ["Child", "Adult"],
                servicesData: {
                    data: {},
                    message: "",
                    color: ""
                }
            }
        },
        watch: {

            "customerData.ExchangeData": {
                handler: function (val) {
                    if (val) {

                        let exchange = this.exchangeRates.filter(response => response.id == val)
                        let curr = exchange[0].id.split('-')
                        this.customerData.fromCurrency = curr[0]
                        this.customerData.toCurrency = curr[1]
                        /*this.customerData.fromAmount = 1*/
                        this.customerData.unitExchangeRate = parseInt(exchange[0].value)
                        if (this.customerData.fromAmount) {
                            this.customerData.toAmount = this.customerData.fromAmount * this.customerData.unitExchangeRate
                        }
                    }
                },
                deep: true
            },
            "customerData.fromAmount": {
                handler: function (val) {
                    if (val) {
                        this.customerData.toAmount = val * this.customerData.unitExchangeRate
                        if (this.isTypeBuy) {
                            axios.get('MoneyExchange/DDLBuyingExchangeRateListAsync/' + val).then(response => {
                                this.exchangeRates = response.data;
                            }).catch(error => console.log(error.response))
                        }
                    }
                },
                deep: true
            }
        },
        props: ['editItemIndex']
        ,
        computed: {
            isTypeBuy() {
                return this.customerData.rateType === "Buy";
            }
        },
        methods: {
            dialogueClose() {
                console.log(this.servicesData)
                this.$emit("formResponse", this.servicesData);
            },

            editFormSubmit() {
                var formData = new FormData()

                formData.append("PersonInformationID", this.customerData.personInformationID);
                formData.append("branchModuleID", this.customerData.branchModuleID);
                formData.append("firstName", this.customerData.firstName);
                formData.append("lastName", this.customerData.lastName);
                formData.append("gender", this.customerData.gender);
                formData.append("dateOfBirth", this.customerData.dateOfBirth);
                formData.append("ageGroup", this.customerData.ageGroup);
                formData.append("nationality", this.customerData.nationality);
                formData.append("country", this.customerData.country);
                formData.append("state", this.customerData.state);
                formData.append("citizenShipNumber", this.customerData.citizenShipNumber || "");
                formData.append("passportNumber", this.customerData.passportNumber || "");
                formData.append("licenseNumber", this.customerData.licenseNumber || "");
                formData.append("otherID", this.customerData.otherID || "");
                formData.append("document", this.customerData.updateDocument);
                formData.append("isVerifiedDocument", this.customerData.isVerifiedDocument);
                formData.append("isImportFromExcel", false);
                formData.append("fromCurrency", this.customerData.fromCurrency);
                formData.append("toCurrency", this.customerData.toCurrency);
                formData.append("customerType", this.customerData.personType);
                formData.append("fromAmount", this.customerData.fromAmount);
                formData.append("toAmount", this.customerData.toAmount);
                formData.append("exchangeRate", this.customerData.exchangeRate);
                formData.append("rateType", this.customerData.rateType);
                formData.append("issuedDate", this.customerData.issuedDate);
                formData.append("issuedBy", this.customerData.issuedBy);
                axios.post('MoneyExchange/UpdateCustomerInformationAsync', formData).then((response) => {
                    if (response.data.success) {
                        this.message.status = true
                        this.servicesData.data = response.data
                        this.servicesData.message = "Issue updated Succcessfully"
                        this.servicesData.color = "success"
                        this.dialogueClose()
                    }
                })
                    .catch((response) => {
                        this.servicesData.data = response.data
                        this.servicesData.message = "Error Adding Service, Please Contact Admin"
                        this.servicesData.color = "error"
                    })
            },
            async getState(val) {
                const stateList = await axios.get('Shared/StateListByCountryCode?CountryCode=' + val);
                this.state = stateList.data
                console.log(this.state)
            },
            formData() {
                axios.get("Shared/GetAgeGroupList").then(response => {
                    this.PassengerTypes = response.data;
                }).catch(error => console.log(error.response))
                axios.get("Shared/CountryList").then(response => {
                    this.countries = response.data;
                }).catch(error => console.log(error.response))

                this.callExchangeRate()
                this.getEditData().then(response => {
                    this.customerData = response.data
                    this.customerData.ExchangeData = `${response.data.fromCurrency}-${response.data.toCurrency}`
                    this.getState(this.customerData.country)
                }).catch(err => console.log(err.response))


            },
            async getEditData() {
                return await axios.get('MoneyExchange/GetCustomerInformationByIDAsync/' + this.editItemIndex)
            },
            callExchangeRate() {
                this.customerData.fromAmount = 1
                if (!this.isTypeBuy) {
                    axios.get('MoneyExchange/DDLSellingExchangeRateListAsync').then(response => {
                        this.exchangeRates = response.data;
                    }).catch(error => console.log(error.response))
                }
                if (this.isTypeBuy) {
                    axios.get('MoneyExchange/DDLBuyingExchangeRateListAsync/' + this.customerData.fromAmount).then(response => {
                        this.exchangeRates = response.data;
                    }).catch(error => console.log(error.response))
                }
            }
        },
        mounted() {
            this.formData();
        },
    }
</script>

<style scoped>

</style>